import React from "react";
import SEO from "./SEO";

function WhyUs() {
  return (
    <section id="whyme" className="whyme" aria-labelledby="whyme-title">
      <SEO
        title="Why Choose Sukun Cloud Consulting"
        description="Why work with Sukun? Real-world experience, certifications, fast delivery, and clear documentation for Cloud & DevOps projects."
        keywords={["Cloud Expert", "DevOps Engineer", "Certified GCP", "Kubernetes Expert", "Sukun", "Cloud Consultant"]}
      />
      <h2 id="whyme-title">Why Choose Sukun Cloud Consulting?</h2>
      <ul>
        <li>✅ Hands-on experience managing systems at global scale</li>
        <li>✅ Certified GCP Cloud Engineer & Kubernetes Expert</li>
        <li>✅ Fast, reliable, and cost-efficient cloud solutions</li>
        <li>✅ Transparent communication & detailed documentation</li>
      </ul>
    </section>
  );
}

export default WhyUs;